"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductWarranty = void 0;
const react_1 = __importDefault(require("react"));
const divider_1 = require("../divider");
const themed_text_1 = require("../themed-text");
const styles_1 = require("./styles");
const ProductWarranty = (props) => {
    const { title, subHeading, productWarrantyText } = props;
    return title != undefined ? (react_1.default.createElement(styles_1.StyledWarrantyContainer, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement(themed_text_1.ThemedHeading, { headingLevel: 3, "data-cy": "product-warranty" }, title),
            react_1.default.createElement(divider_1.Divider, { margin: '5px' }),
            react_1.default.createElement(themed_text_1.ThemedSpan, null,
                react_1.default.createElement(themed_text_1.ThemedSpan, { bold: true },
                    subHeading,
                    "\u00A0"),
                " ",
                react_1.default.createElement(themed_text_1.ThemedSpan, null, productWarrantyText))))) : null;
};
exports.ProductWarranty = ProductWarranty;
__exportStar(require("./types"), exports);
